import LpStepTwoRef from './step2';
import LpCustomizations from './customizations';
import LpSlackRefs from './slack';
import lpApp from '../lp_app';

/*
 * Project: LegalPlace assistant
 * File: src/app/refs/refs.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

/**
 * The references class
 */

class LpReferences {
  constructor() {
    this.options = {};
    this.variables = {};
    this.views = {};
    this.parenting = {};
    this.two_steps = new LpStepTwoRef();
    this.customs = new LpCustomizations();
    this.slack_notification = new LpSlackRefs();
    // Adding mandatory options and variables by sections.
    this.mandatory_options = {};
    this.mandatory_variables = {};
  }

  addCustomizationsReference(model) {
    this.customs.buildCustomizations(model);
  }

  addOptionsReference(optRefs) {
    this.options = optRefs;
    this.two_steps.buildOptions(optRefs);
  }

  addVariablesRefernce(varRefs) {
    this.variables = varRefs;
    this.two_steps.buildVariables(varRefs);
  }

  addViewsRefernce(vrefs) {
    this.views = vrefs;
  }

  addSectionsReference(secs) {
    this.sections = secs;
    this.two_steps.buildSections(secs);
  }

  addSlackNotification(slkrefs) {
    this.slack_notification.initSlackRef(slkrefs);
  }

  addMandatpryOptions(ops) {
    const keys = Object.keys(ops);
    keys.forEach((keysIdx) => {
      const idx = ops[keysIdx];
      if (('mandatory' in idx.meta) && (idx.meta.mandatory)) {
        if (!(idx.meta.parent_section in this.mandatory_options)) {
          this.mandatory_options[idx.meta.parent_section] = [idx.meta.id];
        }
      }
    });
  }

  addMandatoryVariables(vars) {
    const keys = Object.keys(vars);
    keys.forEach((keysIdx) => {
      const idx = vars[keysIdx];
      if (('mandatory' in idx) && (idx.mandatory)) {
        const grandpaIdx = lpApp.references.options[lpApp.indexes.grandpa_vars.getVGrandpa(idx.id)];
        if (!(grandpaIdx.meta.parent_section in this.mandatory_variables)) {
          this.mandatory_variables[grandpaIdx.meta.parent_section] = [idx.id];
        }
      }
    }, this);
  }

  /**
     * Here we have the total control on errors of low level
     */
  getVariable(id) {
    return this.variables[id];
  }

  getOption(id) {
    return this.options[id];
  }

  getSection(id) {
    return this.sections[id];
  }
}


export default LpReferences;



// WEBPACK FOOTER //
// ./src/app/refs/refs.js